import { requestDelete, requestGet, requestPost } from "Common/Provider/RestClient"
import { useMutation, useQuery } from "@tanstack/react-query"

export function useBrowseHolidayDate({ sort = 'code', order = 'asc', expands = [], pageSize = 20, currentPage = 1, keyword, onSuccess, startDate, endDate, }) {
    const path = `/human-resource/attendance/holiday-date`
    const data = useQuery({
        queryKey: [path, sort, order, pageSize, keyword, currentPage, startDate, endDate],
        queryFn: () => requestGet(path, { sort, order, keyword, pageSize, currentPage: currentPage || 1, expand: expands.join(','), startDate, endDate }),
        onSuccess: (response) => onSuccess ? onSuccess(response) : null,
    })
    return data
}


export function useCreateHolidayDate({ onSuccess, onError }) {
    const mutation = useMutation({
        mutationFn: ({ date, title }) => {
            const path = `/human-resource/attendance/holiday-date`
            return requestPost(path, {
                date, title,
            })
        },
        onSuccess: (response) => onSuccess ? onSuccess(response) : null,
        onError: (error) => onError ? onError(error) : null,
    })
    return mutation
}

export function useDeleteHolidayDate({ onSuccess, onError }) {
    const mutation = useMutation({
        mutationFn: ({ ID, password }) => {
            const path = `/human-resource/attendance/holiday-date/${ID}`
            return requestDelete(path, { password })
        },
        onSuccess: (response) => onSuccess ? onSuccess(response) : null,
        onError: (error) => onError ? onError(error) : null,
    })
    return mutation
}
